import { DatePicker, Form, FormItemProps } from 'antd';
import moment from 'moment';
import { FC } from 'react';

import './styles.scss';

interface FormItemDatePickerPropsType extends FormItemProps {
  label: React.ReactNode;
  description?: string;
  name: string;
}

const FormItemDatePicker: FC<FormItemDatePickerPropsType> = (props) => {
  const { label, description, name } = props;

  const disabledDate = (current) => {
    const customDate = moment().format('YYYY-MM-DD');
    return current && current < moment(customDate, 'YYYY-MM-DD');
  };

  return (
    <Form.Item
      {...props}
      tooltip={description}
      className="form__item-date-picker"
      label={
        <div className="form-item__label">
          <span>{label}</span>
        </div>
      }
      name={name}
    >
      <DatePicker allowClear={false} disabledDate={disabledDate} />
    </Form.Item>
  );
};

export default FormItemDatePicker;
